<template>
  <div class="tabs-common">
    <div class="mb-3 row">
      <!-- <label class="col-sm-3 col-form-label">Customs Office</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.cust_office" maxlength="20" placeholder="Customs Office">
        <label>Customs Office</label>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-3 col-form-label">Mode of Transport</label> -->
      <div class="col-sm-10">
        <!-- <input type="text" class="form-control" v-model="tab_data.transp_mode" maxlength="20"> -->
        <NewSelectWrapper type="transp_mode" v-model="tab_data.transp_mode" placeholder="Mode of Transport"/>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-3 col-form-label">Country of Origin</label> -->
      <div class="col-sm-10">
        <NewSelectWrapper type="country" v-model="tab_data.transp_country" placeholder="Country of Origin"/>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-3 col-form-label">Country of Supply</label> -->
      <div class="col-sm-10">
        <NewSelectWrapper type="country" v-model="tab_data.supply_country" placeholder="Country of Supply"/>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-3 col-form-label">Port of Loading</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.loading_port" maxlength="20" placeholder="Port of Loading">
        <label>Port of Loading</label>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-3 col-form-label">Port of Discharge</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.discharge_port" maxlength="20" placeholder="Port of Discharge">
        <label>Port of Discharge</label>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-3 col-form-label">Inspection Agent</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.insp_agent" maxlength="20" placeholder="Inspection Agent">
        <label>Inspection Agent</label>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-3 col-form-label">Shipment Date</label> -->
      <div class="col-sm-10">
        <NewDatepickerWrapper
          v-model="tab_data.shipment_date"
          type="date"
          placeholder="Shipment Date">
        </NewDatepickerWrapper>
      </div>
    </div>

    <!-- <div class="foot_pagination">
      <img src="@/assets/chevron_left24.png" alt="" v-if="cur_tab_name!='Header'"
           @click="page_change('Names&Parties',1)">
      {{ cur_tab_name }}
      <img src="@/assets/chevron_right24.png" alt="" v-if="cur_tab_name!='Support Information'"
           @click="page_change('Financial',3)">
    </div> -->
  </div>
</template>

<script>
import common from "@/mixins/common-form-m";
import NewSelectWrapper from './../../fields/NewSelectWrapper.vue'
import NewDatepickerWrapper from './../../fields/NewDatepickerWrapper.vue'
export default {
  name: 'tabs-transport',
  props: ['cur_tab_name', 'indata'],
  components: {
    NewSelectWrapper, NewDatepickerWrapper
  },
  data() {
    return {
      tab_data: {
        cust_office: '',
        transp_mode: '',
        transp_country: '',
        supply_country: '',
        loading_port: '',
        discharge_port: '',
        insp_agent: '',
        shipment_date: '',
      }
    }
  },
  mixins: [common],
  methods: {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
